import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { TasaImpuestosComponent } from "../../configuraciones/edit/components/impuestos";
import { ConfiguracionEmpresa, validar as validarEmpresa } from "../../configuraciones/edit/components/configuracionempresa";
import { ConfiguracionCorreo, validar as validarCorreo } from "../../configuraciones/edit/components/configuracioncorreo";

import { ColoniaComponent } from "app/features/componentes/index";

import { CuentasComponent, validar as validarCuentas } from "../../configuraciones/edit/components/contabilidad";
import { ConfigSistemaContabilidad, validar as validarSistemaConta } from "../../configuraciones/edit/components/contabilidad/configsistema";
import { PopupModal } from "../../diseño/items/popupmodal";

import { DireccionComponent } from "../../catalogos/items/sucursales/edit/direccion";
import { obtenerComponenteDireccionColonia } from "app/features/componentes/direccioncolonia";




type Entity = models.ConfigSistemaDTO;

const resource = resources.MatrizTarifa;
const DireccionColoniaComp = obtenerComponenteDireccionColonia<Entity>("IdColonia", "DireccionLogistica", "Dirección");
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
}

function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        IdTarifa: validation.required,
        ConfiguracionEmpresa: validation.subrule(validarEmpresa),
        ConfiguracionCorreo: validation.subrule(validarCorreo),

        Contabilidad: validation.subrule(validarCuentas),

        RfcReceptorFacturaPublicoGeneral: validation.required,
        IdArticuloConceptoDeNotaDeCredito: validation.required,
        IdProductoSATConceptoNotaCredito: validation.required,
        IdUnidadSATConceptoNotaCredito: validation.required,

    };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class ConfigSistemaFormNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));
    modals = kea.createModalManager();

    nombreLLave = (x: Props) => (x.value.NombreLlaveConExtensionLogistica ? x.value.NombreLlaveConExtensionLogistica.length : 0) < 20 ? x.value.NombreLlaveConExtensionLogistica || "" : x.value.NombreLlaveConExtensionLogistica.substr(0, 15) + "... .key";
    nombreCertificado = (x: Props) => (x.value.NombreCertificadoConExtensionLogistica ? x.value.NombreCertificadoConExtensionLogistica.length : 0) < 20 ? x.value.NombreCertificadoConExtensionLogistica || "" : x.value.NombreCertificadoConExtensionLogistica.substr(0, 15) + "... .cer";
    nombreCertificadoCompleto = (x: Props) => x.value.NombreCertificadoConExtensionLogistica || "";
    nombreLLaveCompleto = (x: Props) => x.value.NombreLlaveConExtensionLogistica || "";

    private handleOnAgregarFile = async (x: keyof Entity) => {
        const archivo = await kea.upload();
        if (archivo) {
            var aceptedExtensions = x == "LlaveLogistica" ? ["key"] : ["cer"];
            var keyOfNombre: keyof Entity = x == "LlaveLogistica" ? "NombreLlaveConExtensionLogistica" : "NombreCertificadoConExtensionLogistica";
            const name = archivo.name;
            var nombre = archivo.name.split(".");
            var extension = nombre[nombre.length - 1].toLowerCase();
            if (aceptedExtensions.indexOf(extension) != -1) {
                const datos = await kea.blobToBase64(archivo);
                const tipo = archivo.type;
                const viejo = this.props.value;
                var cambio: Partial<Entity> = { [x]: datos, [keyOfNombre]: name };
                if (this.props.onChange)
                    await this.props.onChange({ ...viejo, ...cambio });
            } else {
                await kea.message("Solo se aceptan archivos .key");
                this.setState({ imagen: "" });
            }
        }
    }

    private handleOnDescargarFile = async (x: keyof Entity) => {
        const mensaje = x == "LlaveLogistica" ? ".key" : ".cer"
        if (await kea.yesno("¿Descargar archivo " + mensaje + "?")) {
            var value = this.props.value;
            var keyOfNombre: keyof Entity = x == "LlaveLogistica" ? "NombreLlaveConExtensionLogistica" : "NombreCertificadoConExtensionLogistica";
            kea.download(kea.base64ToBlob(value[x] as string, 'application/pkix-cert'), value[keyOfNombre]);
        }
    }

    private onDeleteFile = async (x: keyof Entity) => {
        const mensaje = x == "LlaveLogistica" ? ".key" : ".cer"
        if (await kea.yesno("Eliminar archivo " + mensaje + "?")) {
            var keyOfNombre: keyof Entity = x == "LlaveLogistica" ? "NombreLlaveConExtensionLogistica" : "NombreCertificadoConExtensionLogistica";
            const viejo = this.props.value;
            var cambio: Partial<Entity> = { [x]: "", [keyOfNombre]: "" };
            await this.props.onChange({ ...viejo, ...cambio });
        }
    }

    render() {
        const { value, onGuardar } = this.props;
        const getField = this.getField;
        const hasError = this.hasError(this.props);
        const Tarifa = getField(selectores.Tarifa);
        const Number = getField(kea.Number);
        const Text = getField(kea.Text);
        const Articulo = getField(selectores.Articulo);
        const ContenidoSobre = getField(selectores.ContenidoSobre);
        const Colonia = getField(ColoniaComponent);
        const Tasas = getField(TasaImpuestosComponent);
        const ConfigEmp = getField(ConfiguracionEmpresa);
        const Cuentas = getField(CuentasComponent);
        const SistemaConta = getField(ConfigSistemaContabilidad);
        const Correo = getField(ConfiguracionCorreo);
        const FormaPagoSAT = getField(selectores.ClaveFormaPagoSat);
        const MetodoPagoSAT = getField(selectores.ClaveMetodoPagoSat);
        const UnidadSAT = getField(selectores.ClaveUnidadSat);
        const ProductoSAT = getField(selectores.ClaveProductoSat);
        const Clientes = getField(selectores.Cliente);
        const MatrizTarifa = getField(selectores.MatrizTarifa);


        const SiNo = getField(selectores.SiNo);
        const AumentoDisminucion = getField(selectores.AumentoDisminucion);
        let CambiarMatrizTarifa = true;

        const nombreCertificado = this.nombreCertificado(this.props);
        const nombreLLave = this.nombreLLave(this.props);
        const nombreCertificadoCompleto = this.nombreCertificadoCompleto(this.props);
        const nombreLLaveCompleto = this.nombreLLaveCompleto(this.props);

        return (
            <div>
                <kea.Title titulo="Configuración del sistema Logistica" onRegresar={() => history.go("/login")} />

                {kea.autogrid(3, [
                    <Articulo field="IdArticuloFleteLogistica" label="Articulo flete" />,
                ])}

                {kea.autogrid(6, [
                    <Text field="ContraseñaLlaveLogistica" label="Contraseña  SAT:"  />,
                    <span>
                        {
                            <span>
                                <kea.Button style="success" onClick={() => this.handleOnAgregarFile("LlaveLogistica")}   >Agregar .key </kea.Button>
                                <kea.Link style="link" tooltip={nombreLLaveCompleto} onClick={() => this.handleOnDescargarFile("LlaveLogistica")}>
                                    {nombreLLave}
                                </kea.Link>
                                <kea.IconButton iconClass={fa("trash-o")} style="danger" onClick={() => this.onDeleteFile("LlaveLogistica")} tooltip="eliminar .key" />
                            </span>
                        }
                    </span>,
                    <span>
                        {
                            <span>
                                <kea.Button style="success" onClick={() => this.handleOnAgregarFile("CertificadoLogistica")} >Agregar .cer </kea.Button>
                                <kea.Link style="link" tooltip={nombreCertificadoCompleto} onClick={() => this.handleOnDescargarFile("CertificadoLogistica")}>
                                    {nombreCertificado}
                                </kea.Link>
                                <kea.IconButton iconClass={fa("trash-o")} style="danger" onClick={() => this.onDeleteFile("CertificadoLogistica")} tooltip="eliminar .cer" />
                            </span>
                        }
                    </span>,
                    <Clientes field="IdClienteConfigLogistica" label="Cliente default para Logistica"  />,

                ])}
                <br/>
                <kea.Title titulo="Datos de la empresa" size="h4" />

                <Colonia field="IdColoniaLogistica" label="Dirección de la empresa:" />
                <ConfigEmp field="ConfiguracionEmpresaLogistica" />
                <Cuentas field="ContabilidadLogistica" label="Cuentas contables" />
                <SistemaConta field="ConexionContabilidadLogistica" label="Conexión con sistema de contabilidad" />

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={hasError} />
                    </div>
                </div>

                {this.modals.component}
            </div>);
    }
}

export const ConfigSistemaForm = componentToRx(ConfigSistemaFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/configuraciones logistica/edit/form.tsx